<template>
  <dropdown
    ref="dropdown"
    v-model="replyButtonOpen"
    :menu-right="menuRight"
    :dropup="isDropup"
    class="msg-quote-container"
    :class="{ 'dropdown-active': replyButtonOpen }"
  >
    <btn class="msg-quote-btn btn-sem-style">
      <span class="icon-caret-down" />
    </btn>

    <template slot="dropdown">
      <li>
        <a class="reply-action" role="button" @click="handleQuoteMessage">
          <span class="icon-reply" :style="`color: rgba(${bgColorRGBA});`" />

          <span class="space-left-sm">
            {{ $t('conversation.quoteButton') }}
          </span>
        </a>
      </li>
    </template>
  </dropdown>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import { isClient } from '@/helpers'

  export default {
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        replyButtonOpen: false,
        menuRight: true
      }
    },
    computed: {
      ...mapGetters(['conversationMessages', 'settings']),
      bgColorRGBA() {
        return this.settings.bgColorRGBA
      },
      isDropup() {
        const lastMessageKey =
          this.conversationMessages[this.conversationMessages.length - 1].key

        return lastMessageKey === this.message.key
      },
      isClientMessage() {
        return isClient(this.message.user.type)
      }
    },
    watch: {
      replyButtonOpen() {
        this.setOverlayOpen(this.replyButtonOpen)
      }
    },
    mounted() {
      this.isMenuRight()
    },
    methods: {
      ...mapActions(['quoteMessage', 'setOverlayOpen']),
      isMenuRight() {
        if (!this.isClientMessage) {
          const messageBox =
            this.$parent.$el.querySelector('.octadesk-chat-msg')

          if (messageBox && messageBox.offsetWidth < 160) {
            this.menuRight = false
          }
        }
      },
      handleQuoteMessage() {
        this.quoteMessage(this.message)
      }
    }
  }
</script>

<style lang="scss">
  .octadesk-chat-msg {
    &:hover {
      .msg-quote-container {
        display: block;
      }
    }
  }

  .msg-quote-container {
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 14px;
    display: none;
    &.dropdown-active {
      display: block !important;
    }

    .reply-action {
      font-size: 14px;
      display: flex;
      align-items: center;
      text-align: left;
      color: #666 !important;
      cursor: pointer;
    }
  }

  .msg-quote-btn {
    background: transparent;
    color: #333;
    border: none !important;
    padding: 0 !important;
    box-shadow: none !important;
    width: 18px;
    height: 18px;
  }
  .msg-quote-btn:active {
    background: transparent !important;
    color: #333 !important;
  }
</style>
